<div class="received-po">
  <h1>Received purchase orders</h1>
  <p class="subtitle">Purchase orders issued to your organization. Accept or reject issued orders, then invoice accepted ones.</p>

  <div *ngIf="loading" class="state">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div *ngIf="!loading && orders.length === 0" class="state empty">
    No purchase orders have been issued to you yet.
  </div>

  <div class="cards" *ngIf="!loading">
    <div class="card" *ngFor="let po of orders">
      <button type="button" class="card-body" (click)="viewPo(po)">
        <div class="card-top">
          <strong>{{ po.po_ref || ('PO #' + po.id) }}</strong>
          <span class="status">{{ po.po_status || 'draft' }}</span>
        </div>
        <p>{{ po.project_name }}</p>
        <p class="muted">From {{ po.issuer_org_name || 'planner' }} <span *ngIf="po.boq_code">· {{ po.boq_code }}</span></p>
        <p>{{ po.item_count || 0 }} item(s) · {{ formatCurrency(po.total_value) }}</p>
      </button>
      <div class="card-actions" *ngIf="canRespond(po)">
        <button mat-raised-button color="primary" type="button" [disabled]="busyId === po.id" (click)="accept(po, $event)">Accept</button>
        <button mat-stroked-button color="warn" type="button" [disabled]="busyId === po.id" (click)="reject(po, $event)">Reject</button>
      </div>
    </div>
  </div>
</div>
